import { HttpClient } from '@angular/common/http';
import { map } from 'rxjs/operators';
// 3rd party imports
import { classToPlain, plainToClass } from 'class-transformer';
// Service imports
import { MPCacheRegistrationService } from '../../../../_services/shared-services/mp-cache-registration-service';
// Constant imports
import { URLConstants } from '../../../../_constants/url-constants';
import { CacheDuration } from '../../../../_constants/cache-duration';
import { JournalEntryDetailsResultDto } from '../../_models/general-ledger/journal-entry/journal-entry-details-result-dto';
import { TransactionLogResultDto } from '../../_models/common/transaction-log-result-dto';
import * as i0 from "@angular/core";
import * as i1 from "@angular/common/http";
import * as i2 from "../../../../_services/shared-services/mp-cache-registration-service";
export class JournalEntryDetailService {
    constructor(httpClient, cacheRegistrationService) {
        this.httpClient = httpClient;
        this.cacheRegistrationService = cacheRegistrationService;
    }
    getJournalEntryDetails(param) {
        const url = `${URLConstants.ccCBGLJournalEntryApiUrl}/detail${param.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, param.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(JournalEntryDetailsResultDto, response)));
    }
    getJournalEntryDetailHistory(param) {
        const url = `${URLConstants.ccCBGLJournalEntryApiUrl}/history${param.getQueryString()}`;
        this.cacheRegistrationService.registerForCache(url, param.clearCache);
        const headers = this.cacheRegistrationService.getHttpRequestHeaders(url, CacheDuration.fifteenMinute);
        const options = { headers };
        return this.httpClient
            .get(url, options)
            .pipe(map((response) => plainToClass(TransactionLogResultDto, response)));
    }
    getJEAttachmentfile(param) {
        const url = `${URLConstants.ccCBGLJournalEntryApiUrl}/attachment${param.getQueryString()}`;
        return this.httpClient
            .get(url, { responseType: 'arraybuffer' })
            .pipe(map((responseData) => new Blob([responseData])));
    }
    updateJEAttachments(params) {
        const url = `${URLConstants.ccCBGLJournalEntryApiUrl}/attachment`;
        return this.httpClient.post(url, classToPlain(params)).pipe(map((response) => response));
    }
}
JournalEntryDetailService.ngInjectableDef = i0.ɵɵdefineInjectable({ factory: function JournalEntryDetailService_Factory() { return new JournalEntryDetailService(i0.ɵɵinject(i1.HttpClient), i0.ɵɵinject(i2.MPCacheRegistrationService)); }, token: JournalEntryDetailService, providedIn: "root" });
